module.exports = __webpack_public_path__ + "static/media/banner-right.5541c2f5.svg";